function ttqSeguro(evento, params = {}) {
    if (typeof window.ttq?.track !== "function") return;
    window.ttq.track(evento, params);
}



export function ttqVerContenido({ nombre, id, precio, categoria }) {
    ttqSeguro("ViewContent", {
        content_id:       id,
        content_name:     nombre,
        content_type:     "product",
        content_category: categoria || "",
        value:            precio,
        currency:         "COP",
    });
}



export function ttqAgregarAlCarrito({ nombre, id, precio, categoria }) {
    ttqSeguro("AddToCart", {
        content_id:       id,
        content_name:     nombre,
        content_type:     "product",
        content_category: categoria || "",
        value:            precio,
        currency:         "COP",
    });
}



export function ttqIniciarReserva({ nombre, id, precio }) {
    ttqSeguro("InitiateCheckout", {
        content_id:   id,
        content_name: nombre,
        content_type: "product",
        value:        precio,
        currency:     "COP",
        quantity:     1,
    });
}



export function ttqCompraCompletada({ transaccionId, monto, moneda = "COP" }) {
    ttqSeguro("CompletePayment", {
        content_type: "product",
        order_id:     transaccionId,
        value:        monto,
        currency:     moneda,
    });
}

// Evento aparte (sin value/currency) para no duplicar el conteo de compras ni el ingreso reportado.
export function ttqPrimeraCompraDescuento({ transaccionId, montoDescuento }) {
    ttqSeguro("PrimeraCompraDescuento", {
        order_id:        transaccionId,
        monto_descuento: montoDescuento,
    });
}



export function ttqAgregarFavorito({ nombre, id, precio, categoria }) {
    ttqSeguro("AddToWishlist", {
        content_id:       id,
        content_name:     nombre,
        content_type:     "product",
        content_category: categoria || "",
        value:            precio,
        currency:         "COP",
    });
}



export function ttqRegistroCompletado({ metodo = "email" }) {
    ttqSeguro("CompleteRegistration", {
        content_name: "Registro Zervicy",
        method:       metodo, // "email", "google", "apple"
    });
}



export function ttqPonerEnRevision({ idServicio, categoria }) {
    ttqSeguro("PonerEnRevision", {
        content_id:       idServicio,
        content_category: categoria,
    });
}



export function ttqSuscribirKlaviyo({ origen = "formulario" }) {
    ttqSeguro("Subscribe", {
        origen, // "footer", "cuenta", "registro"
    });
}



export function ttqClickDescargaApp({ plataforma }) {
    ttqSeguro("ClickButton", {
        content_name: "descarga_app",
        plataforma,   // "ios" o "android"
    });
}



// "Search" es un evento ESTÁNDAR de TikTok — se dispara en las 4 variantes de búsqueda.
export function ttqBusquedaRealizada({ termino, categoria }) {
    ttqSeguro("Search", {
        search_string: termino || "",
        content_category: categoria || "",
    });
}
